import { render, staticRenderFns } from "./addEmployeePersonal.vue?vue&type=template&id=268515e2&scoped=true"
import script from "./addEmployeePersonal.vue?vue&type=script&lang=js"
export * from "./addEmployeePersonal.vue?vue&type=script&lang=js"
import style0 from "./addEmployeePersonal.vue?vue&type=style&index=0&id=268515e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268515e2",
  null
  
)

export default component.exports